import { render, staticRenderFns } from "./bidding.vue?vue&type=template&id=7fe70532&scoped=true"
import script from "./bidding.vue?vue&type=script&lang=js"
export * from "./bidding.vue?vue&type=script&lang=js"
import style0 from "./bidding.vue?vue&type=style&index=0&id=7fe70532&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe70532",
  null
  
)

export default component.exports